import { render, staticRenderFns } from "./DashboardWorkProjection.vue?vue&type=template&id=43ae5c84&"
import script from "./DashboardWorkProjection.vue?vue&type=script&lang=js&"
export * from "./DashboardWorkProjection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports